"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAxeptaPaymentRequest = void 0;
class GetAxeptaPaymentRequest {
    constructor(paymentsService) {
        this.paymentsService = paymentsService;
    }
    execute(request) {
        const { amount, userRedirectUrl } = request;
        return this.paymentsService.getAxeptaPaymentRequest({
            amount,
            userRedirectUrl,
        });
    }
}
exports.GetAxeptaPaymentRequest = GetAxeptaPaymentRequest;
